<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/banner-zh.png'"
        :alt="$t('langs.homepower')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/banner-en.png'"
        :alt="$t('langs.homepower')"
      />
    </div>
    <div class="power_title flex-row_home">
      <div class="outer_line flex-col_home"></div>
      <div class="outer_text">
        <span class="home_word_one">{{
          $t("langs.energystoragebattery")
        }}</span>
      </div>
    </div>
    <div class="home_about_center">
      <div class="main_home_left">
        <div class="info_home" style="margin-top: 10px">
          {{ $t("langs.highvoltage") }}
        </div>
        <router-link to="/centerpower">
          <img class="main_pic" :src="this.$path + '/assets/images/power_about.png'"
            style="margin-top: 50px"
        /></router-link>
      </div>
      <div class="main_home_right">
        <div class="home_word_about">
          {{ $t("langs.energystoragebatterybox") }}
        </div>
        <div class="home_line_botton">
          <div
            class="main_menu flex-col_home"
            @mouseover="mouseOver(1)"
            @mouseleave="mouseLeave"
            :style="active1"
          >
            <div class="outer_menu flex-col_home">
              <img
                class="icon_images"
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/more_power.png'"
              />
              <span class="text_word">{{ $t("langs.moreavailable") }}</span>
              <span
                class="text_menu"
                :style="this.active1 ? 'display: block;' : 'display: none;'"
              >
                {{ $t("langs.discharge") }}</span
              >
              <span
                class="text_menu"
                :style="this.active1 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.optimization") }}</span
              >
            </div>
          </div>
          <div
            class="main_menu flex-col_home"
            @mouseover="mouseOver(2)"
            @mouseleave="mouseLeave"
            :style="active2"
          >
            <div class="outer_menu flex-col_home">
              <img
                class="icon_images"
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/live.png'"
              />
              <span class="text_word">{{ $t("langs.flexible") }}</span>
              <span
                class="text_menu"
                :style="this.active2 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.modulardesign") }}</span
              >
              <span
                class="text_menu"
                :style="this.active2 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.flexibleexpansion") }}</span
              >
            </div>
          </div>
          <div
            class="main_menu flex-col_home"
            @mouseover="mouseOver(3)"
            @mouseleave="mouseLeave"
            :style="active3"
          >
            <div class="outer_menu flex-col_home">
              <img
                class="icon_images"
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/soft.png'"
              />
              <span class="text_word">{{ $t("langs.reliable") }}</span>
              <span
                class="text_menu"
                :style="this.active3 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.lithium") }}</span
              >
            </div>
          </div>
        </div>
        <div class="home_line_botton">
          <div
            class="main_menu flex-col_home"
            @mouseover="mouseOver(6)"
            @mouseleave="mouseLeave"
            :style="active6"
          >
            <div class="outer_menu flex-col_home">
              <img
                class="icon_images"
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/nice.png'"
              />
              <span class="text_word">{{ $t("langs.perfectly") }}</span>
              <span
                class="text_menu"
                :style="this.active6 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.multiphaseinverters") }}</span
              >
            </div>
          </div>
          <div
            class="main_menu flex-col_home"
            @mouseover="mouseOver(5)"
            @mouseleave="mouseLeave"
            :style="active5"
          >
            <div class="outer_menu flex-col_home">
              <img
                class="icon_images"
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/open.png'"
              />
              <span class="text_word">{{ $t("langs.quickstart") }}</span>
              <span
                class="text_menu"
                :style="this.active5 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.automatic") }}</span
              >
            </div>
          </div>
          <div
            class="main_menu flex-col_home"
            @mouseover="mouseOver(4)"
            @mouseleave="mouseLeave"
            :style="active4"
          >
            <div class="outer_menu flex-col_home">
              <img
                class="icon_images"
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/setup.png'"
              />
              <span class="text_word">{{ $t("langs.installation") }}</span>
              <span
                class="text_menu"
                :style="this.active4 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.powermodule") }}</span
              >
              <span
                class="text_menu"
                :style="this.active4 ? 'display: block;' : 'display: none;'"
                >{{ $t("langs.batterymodule") }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mode_bms_hone flex-col_home">
      <div class="section_block flex-row_home">
        <div class="layer_home_one flex-col_home"></div>
        <div class="layer_home_two">
          <span class="word_line_bms_hone">BMS</span>
        </div>
      </div>
      <div class="section_block_home flex-row_home">
        <div
          class="flex-col_home"
          @mouseover="mouseOver(100)"
          @mouseleave="mouseLeave"
        >
          <img
            referrerpolicy="no-referrer"
            style="width: 512px; height: 380px"
            :src="this.$path + '/assets/images/CardBMS-01.png'"
          />
          <router-link to="/centerbms">
            <div
              class="layer_aray_bms flex-col_home"
              @mouseover="mouseOver(100)"
              @mouseleave="mouseLeave"
              :style="active100"
            >
              <span class="info_aray_bms" v-if="!active100">{{
                $t("langs.automotivebms")
              }}</span>
              <div class="info_aray_bms" v-if="active100">
                <div class="main_home_power flex-col_home">
                  <div
                    class="group_block_power_one flex-col_home"
                    style="
                      color: rgba(255, 255, 255, 1);
                      font-size: 18px;
                      text-indent: -1em;
                    "
                  >
                    01
                  </div>
                  <span class="word_aray_bms">{{ $t("langs.automotivebms") }}</span>
                  <div class="group_block_power_two flex-col_home"></div>
                  <span class="paragraph_home_power">{{
                    $t("langs.monitoringofsystem")
                  }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div
          class="flex-col_home"
          @mouseover="mouseOver(200)"
          @mouseleave="mouseLeave"
        >
          <img
            referrerpolicy="no-referrer"
            style="width: 512px; height: 380px"
            :src="this.$path + '/assets/images/CardBMS-02.png'"
          />
          <router-link to="/centerbms">
            <div
              class="layer_aray_bms flex-col_home"
              @mouseover="mouseOver(200)"
              @mouseleave="mouseLeave"
              :style="active200"
            >
              <span class="info_aray_bms" v-if="!active200">{{
                $t("langs.highstoragembs")
              }}</span>
              <div class="info_aray_bms" v-if="active200">
                <div class="main_home_power flex-col_home">
                  <div
                    class="group_block_power_one flex-col_home"
                    style="
                      color: rgba(255, 255, 255, 1);
                      font-size: 18px;
                      text-indent: -1em;
                    "
                  >
                    02
                  </div>
                  <span class="word_aray_bms">{{ $t("langs.highstoragembs") }}</span>
                  <div class="group_block_power_two flex-col_home"></div>
                  <span class="paragraph_home_power">
                    {{ $t("langs.softwarecamera") }}
                  </span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="mode_block_home">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        usemap="#cloudmap"
        :src="this.$path + '/assets/images/power-cloud-zh.png'"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        usemap="#cloudmap"
        :src="this.$path + '/assets/images/power-cloud-en.png'"
      />
    </div>
    <div class="mode_title_home flex-row_home">
      <div class="mode_home_wifi">
        <div class="layer_aray_wifi flex-row_home">Aray WiFi</div>
        <span class="word_aray_wifi">{{ $t("langs.communication") }}</span>
        <span class="word_detail_power">
          {{ $t("langs.storageinverter") }}
        </span>
        <div
          :class="
            this.$store.state.currentLang === 'en' ? 'image100en' : 'image100zh'
          "
        >
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/iphone_wifi.png'"
          /><span class="imagespan">{{ $t("langs.connectpc") }}</span>
        </div>
        <div
          :class="
            this.$store.state.currentLang === 'en' ? 'image100en' : 'image100zh'
          "
        >
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/monitor.png'"
          /><span class="imagespan">{{ $t("langs.nemotenetwork") }}</span>
        </div>
        <div
          :class="
            this.$store.state.currentLang === 'en' ? 'image100en' : 'image100zh'
          "
        >
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/upload.png'"
          /><span class="imagespan">{{ $t("langs.firmware") }}</span>
        </div>
      </div>
      <div class="mode_wifi_home flex-col_home">
        <router-link to="/centerwifi">
          <img
            class="pictrue"
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/wifimode.png'"
        /></router-link>
      </div>
    </div>
    <div class="mode_home_power flex-row_home">
      <div class="box_home_one flex-col_home"></div>
      <div class="box_home_two">
        <span class="word_home">{{ $t("langs.scheme") }}</span>
      </div>
    </div>
    <div class="scheme_block">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        referrerpolicy="no-referrer"
        :src="this.$path + '/assets/images/scheme-wifi-zh.png'"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        referrerpolicy="no-referrer"
        :src="this.$path + '/assets/images/scheme-wifi-en.png'"
      />
    </div>
    <map name="cloudmap" id="cloudmap">
      <area shape="circle" coords="720,450,50" href="/centercloud" />
    </map>
    <Footer></Footer>
    <Hover></Hover>
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Hover from '../components/hover'
export default {
  name: "homepower",
  components: { Head, Footer,Hover },
  data() {
    return {
      active1: "",
      active2: "",
      active3: "",
      active4: "",
      active5: "",
      active6: "",
      active100: "",
      active200: "",
    };
  },
  methods: {
    // 移入
    mouseOver(index) {
      let style00 = "height:380px;margin-top: -380px";
      let style = "background-color: rgba(255, 255, 255, 1);box-shadow: 0px 0px 7px 0px rgb(0 0 0 / 50%);";

      if (index == 1) {
        this.active1 = style;
      }
      if (index == 2) {
        this.active2 = style;
      }
      if (index == 3) {
        this.active3 = style;
      }
      if (index == 4) {
        this.active4 = style;
      }
      if (index == 5) {
        this.active5 = style;
      }
      if (index == 6) {
        this.active6 = style;
      }
      if (index == 100) {
        this.active100 = style00;
      }
      if (index == 200) {
        this.active200 = style00;
      }
    },
    // 移出
    mouseLeave() {
      this.active1 = "";
      this.active2 = "";
      this.active3 = "";
      this.active4 = "";
      this.active5 = "";
      this.active6 = "";
      this.active100 = "";
      this.active200 = "";
    },
  },
};
</script>

<style>
.home_about_center {
  width: 80%;
  height: auto;
  display: inline-block;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0px 10% 20px 10%;
}

.flex-col_home {
  display: flex;
  flex-direction: column;
}

.flex-row_home {
  display: flex;
  flex-direction: row;
}

.power_title {
  margin-top: 40px;
  margin-bottom: 25px;
  justify-content: left;
  margin-left: 10%;
}

.outer_line {
  width: 40px;
  height: 1px;
  background-color: #00d265;
  margin-top: 26px;
}

.outer_text {
  width: 150px;
  height: 42px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.home_line_botton {
  height: 150px;
  display: block;
}

.home_word_one {
  font-size: 30px;
  color: #333333;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 15px;
}

.section_title {
  width: 278px;
  height: 20px;
  justify-content: space-between;
}

.title_text {
  width: 156px;
  height: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 0.6);
  font-size: 14px;
  white-space: nowrap;
  line-height: 20px;
  text-align: left;
}

.main_home_left {
  overflow-wrap: break-word;
  word-break: normal;
  height: auto;
  width: 40%;
  float: left;
}

.main_home_right {
  overflow-wrap: break-word;
  word-break: normal;
  float: left;
  width: 60%;
  height: auto;
}

.scheme_block {
  z-index: auto;
  height: 600px;
  justify-content: initial;
  margin: 50px 0 0 180px;
}

.scheme_block img {
  width: 1024px;
  border: 0px;
  height: 600px;
}

.info_home {
  width: auto;
  height: 33px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 24px;
  white-space: nowrap;
  line-height: 33px;
  text-align: left;
  align-self: flex-start;
  margin-top: 2px;
}

.home_word_about {
  width: auto;
  height: 128px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  letter-spacing: 1px;
  line-height: 22px;
  text-align: left;
  margin-left: 10%;
}

.image100zh {
  display: inline-block;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding: 0px 30px;
}

.image100zh img {
  height: 84px;
  width: 84px;
  border: 0px;
}

.image100en {
  display: inline-block;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding: 0px 10px;
}

.image100en img {
  height: 84px;
  width: 84px;
  border: 0px;
}

.imagespan {
  display: block;
  color: #aaaaaa;
  font-size: 13px;
  font-weight: 400;
  height: 20px;
  line-height: 20px;
  margin-top: 20px;
}

.main_pic {
  width: 414px;
  height: 328px;
}

.main_menu {
  z-index: 270;
  height: 140px;
  border-radius: 8px;
  width: 206px;
  padding: 5px;
  float: right;
  justify-content: center;
  align-items: center;
}

.outer_menu {
  z-index: auto;
  width: 200px;
  height: 116px;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.icon_images {
  width: 30px;
  height: 30px;
}

.text_word {
  z-index: 230;
  width: 200px;
  height: 25px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  white-space: nowrap;
  line-height: 25px;
  text-align: center;
  margin-top: 12px;
}

.text_menu {
  z-index: 277;
  width: 200px;
  height: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 170, 170, 1);
  font-size: 14px;
  white-space: nowrap;
  line-height: 20px;
  text-align: center;
  align-self: center;
  margin-top: 5px;
}

.mode_bms_hone {
  z-index: 279;
  height: 560px;
  background-color: rgba(216, 216, 216, 0.24);
}

.section_block {
  z-index: auto;
  width: 128px;
  height: 42px;
  justify-content: space-between;
  margin: 40px 0 0 13%;
}

.section_block_home {
  z-index: auto;
  width: 1024px;
  height: 380px;
  justify-content: space-between;
  margin: 40px 0 0 13%;
}

.layer_home_one {
  z-index: 281;
  width: 40px;
  height: 1px;
  background-color: #00d265;
  margin-top: 26px;
}

.layer_home_two {
  z-index: 280;
  width: 68px;
  height: 42px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.word_line_bms_hone {
  font-size: 30px;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main_home_power {
  z-index: auto;
  width: 283px;
  height: 138px;
}

.group_block_power_one {
  z-index: 299;
  width: 24px;
  height: 24px;
  background-color: rgba(216, 216, 216, 0.46);
  border-radius: 50%;
  align-self: flex-start;
  margin-left: 11px;
  margin-top: -120px;
}

.word_aray_bms {
  z-index: 297;
  width: 126px;
  height: 25px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  white-space: nowrap;
  line-height: 25px;
  text-align: left;
  align-self: flex-start;
  margin-top: 21px;
}

.group_block_power_two {
  z-index: 300;
  width: 36px;
  height: 1px;
  background: url("../assets/images/group9.png") -1px 0px no-repeat;
  align-self: flex-start;
  margin-top: 15px;
}

.paragraph_home_power {
  z-index: 298;
  width: 283px;
  height: 40px;
  display: block;
  white-space: normal;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  margin-top: 12px;
}

.layer_aray_bms {
  z-index: 286;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.35);
  margin-top: -50px;
  justify-content: center;
  align-items: center;
}

.info_aray_bms {
  z-index: 287;
  height: 50px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  white-space: nowrap;
  line-height: 50px;
  text-align: center;
}

.mode_block_home {
  z-index: 303;
  height: 640px;
  overflow: hidden;
  margin-top: 60px;
  position: relative;
}

.mode_block_home img {
  width: 100%;
  height: 640px;
  border: 0px;
}

.mode_home_power {
  z-index: auto;
  width: 180px;
  height: 42px;
  justify-content: space-between;
  margin: 60px 0 0 13%;
}

.box_home_one {
  z-index: 315;
  width: 40px;
  height: 1px;
  background-color: #00d265;
  margin-top: 26px;
}

.box_home_two {
  z-index: 316;
  width: 120px;
  height: 42px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.word_home {
  font-size: 30px;
  color: #333333;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mode_title_home {
  z-index: auto;
  height: 460px;
  justify-content: initial;
  margin: 60px 0 10px 13%;
}

.mode_home_wifi {
  z-index: auto;
  width: 580px;
  height: auto;
}

.mode_wifi_home {
  position: relative;
  width: 502px;
  height: 460px;
  overflow: hidden;
}

.word_aray_wifi {
  z-index: 327;
  width: 120px;
  height: 42px;
  display: block;
  overflow-wrap: break-word;
  font-weight: 400;
  color: #333333;
  font-size: 30px;
  white-space: nowrap;
  line-height: 42px;
  text-align: left;
  align-self: flex-start;
  margin-top: 20px;
}

.word_detail_power {
  z-index: 326;
  width: 520px;
  height: 158px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  margin-top: 10px;
  text-overflow: ellipsis;
}

.layer_aray_wifi {
  z-index: 328;
  width: 185px;
  height: 48px;
  font-size: 40px;
  font-weight: bold;
  color: #00d265;
  line-height: 48px;
}

.pictrue {
  z-index: 332;
  position: absolute;
  left: 0;
  top: 0;
  width: 480px;
  height: 460px;
}
</style>



// WEBPACK FOOTER //
// src/view/home_power.vue